import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Animation, Icon } from '@zapier/design-system';
import { Tooltip } from '@zapier/design-system-beta';
import { SIDEBAR_ID } from '../UniversalSidebar/constants';
import { interactiveReset } from '../../../utils/style-mixins/reset';
const Styles = labelStyles('MenuCollapseButton', {
    root: css `
    ${interactiveReset};
    background: none;
    border: none;
    width: var(--zds-size-36, 36px);
    height: var(--zds-size-36, 36px);
    border-radius: var(--zds-radius-pill);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--zds-gray-warm-6, #88827e);
    transition: ${Animation.transitionValue};

    &:hover,
    &:focus {
      background-color: none;
      color: var(--zds-gray-warm-10, #201515);
    }
  `,
});
const MenuCollapseButton = ({ ariaExpanded = false, ariaLabel = undefined, icon = 'navMenu', label = 'Menu', onClick = undefined, }) => {
    return (jsx(Tooltip, { content: label, placement: "right" },
        jsx(Tooltip.FocusableTrigger, { "aria-controls": SIDEBAR_ID, "aria-expanded": ariaExpanded, "aria-label": ariaLabel || label, css: Styles.root, onClick: (event) => {
                if (onClick) {
                    onClick(event);
                }
            }, tag: "button" },
            jsx(Icon, { name: icon, size: 24 }))));
};
export default MenuCollapseButton;
//# sourceMappingURL=MenuCollapseButton.js.map
// @zapier/universal-layout@12.0.36 (43c3ed788)
